<template>
  <div
    v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('view_register_export_invoice')"
    style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <!-- Search container -->
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;">{{ $t("service_history.date_from") }}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="search.fromDate"
                      v-model="search.fromDate"></date-picker>
                  </div>
                </div>
              </div>
              <!-- END Search date_from -->

              <!-- Search date_to -->
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;">{{ $t("service_history.date_to") }}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="search.toDate"
                      v-model="search.toDate"></date-picker>
                  </div>
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('registerExportInvoice.apartmentCode')"
                    v-model="search.apartmentCode"
                  />
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('common.emailOrPhone')"
                    v-model="search.emailOrPhone"
                  />
                </div>
              </div>
              <!-- <div class="col-sm-3 col-md-3 col-lg-3"> -->
              <!-- <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('registerExportInvoice.invoiceServiceType')"
                  v-model="search.invoiceServiceType"
                /> -->
              <!-- <lte-section-select2
                    @selectData="onSelectServiceType"
                    @unselectData="onUnselectServiceType"
                    :data="columnsInvoiceServiceType.data_list"
                    :placeHolder="$t('registerExportInvoice.invoiceServiceType')"
                  ></lte-section-select2> -->
              <!-- </div> -->
            </div>
            <div class="row">
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchCase"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <ul class="nav nav-tabs">
              <li class="active" @click="onClickTabSelect(0)">
                <a data-toggle="tab" href="#userRegisterExportInvoiceId"
                  ><b>{{ $t("registerExportInvoice.title") }}</b></a
                >
              </li>
              <li @click="onClickTabSelect(1)">
                <a data-toggle="tab" href="#userRegisterExportInvoiceId"
                  ><b>{{ $t("common.history") }}</b></a
                >
              </li>
            </ul>
            <div class="tab-content">
              <div
                id="userRegisterExportInvoiceId"
                class="tab-pane fade in active"
              >
                <user-register-export-invoice ref="userRegisterExportInvoice" />
              </div>
            </div>
          </div>
          <div class="box-body"></div>
        </div>
        <!--  -->
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils';
import Loading from "vue-loading-overlay";
import constants from "@/lib/constantsData";
import Enum from "../../../enum/enum";
import UserRegisterExportInvoice from "./UserRegisterExportInvoice";
// import UserRegisterExportInvoiceCancel from "./UserRegisterExportInvoiceCancel";
import datePicker from "vue-bootstrap-datetimepicker";
export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    UserRegisterExportInvoice,
    // UserRegisterExportInvoiceCancel,
    "date-picker": datePicker
    // "lte-section-select2": sectionselect2,
  },
  data() {
    return {
      search: {
        apartmentCode: "",
        emailOrPhone: "",
        invoiceServiceType: [],
        fromDate: null,
        toDate: null
      },
      isLoading: false,
      columnsInvoiceServiceType: {
        data_list: constants.serviceList,
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        isSelectInvoiceStatus: true
      },
      onTabSelect: 0,
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      }
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSearchCase: function() {
      let data = {
        apartmentCode: utils.getCleanStringValue(this.search.apartmentCode),
        emailOrPhone: utils.getCleanStringValue(this.search.emailOrPhone),
        invoiceServiceType: this.search.invoiceServiceType,
        fromDate: utils.getCleanStringValue(this.search.fromDate),
        toDate: utils.getCleanStringValue(this.search.toDate),
        status: this.onTabSelect === 0
            ? [Enum.UserRegisterExportInvoiceStatusEnum.ACTIVATED]
            : [Enum.UserRegisterExportInvoiceStatusEnum.DELETED],
        onTabSelect: this.onTabSelect
      };
      // if (this.onTabSelect === 0) {
      this.$refs.userRegisterExportInvoice.onRefsDataSearch(data);
      // } else {
      //   this.$refs.userRegisterExportInvoiceCancel.onRefsDataSearch(data);
      // }
    },
    onClickTabSelect: function(value) {
      this.onTabSelect = value;
      this.onSearchCase();
    },
    onSelectServiceType: function(data) {
      if (this.search.invoiceServiceType.indexOf(parseInt(data.id)) == -1) {
        this.search.invoiceServiceType.push(parseInt(data.id));
      }
    },
    onUnselectServiceType: function(data) {
      if (this.search.invoiceServiceType.indexOf(parseInt(data.id)) != -1) {
        this.search.invoiceServiceType.splice(
          this.search.invoiceServiceType.indexOf(parseInt(data.id)),
          1
        );
      }
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST"
    ])
  },
  mounted() {
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Invoice/UserRegisterExportInvoiceTabs.vue